/* eslint-disable */
import auth0 from 'auth0-js'
import { AUTH_CONFIG } from './auth0-variables'
import EventEmitter from 'eventemitter3'
import router from '../router'
import store from '@/store'
import loggingService from '@/services/util/loggingService'

const isDebug = false
const lsKeySignedIn = 'isUserSigninWithAuth0'
const lsKeyIdToken = 'id_token'
const lsKeyProfile = 'profile'
const lsKeyExpireAt = 'expires_at'
const loginEvent = 'loginEvent'

const webAuth = new auth0.WebAuth({
    domain: AUTH_CONFIG.domain,
    clientID: AUTH_CONFIG.clientId,
    redirectUri: AUTH_CONFIG.callbackUrl,
    audience: `https://${AUTH_CONFIG.domain}/userinfo`,
    responseType: 'token id_token',
    scope: 'openid profile email'
})

class AuthService extends EventEmitter {

    authenticated = this.isAuthenticated()
    authNotifier = new EventEmitter()
    idToken = null
    profile = null
    tokenExpiry = null

    login (customState) {
        webAuth.authorize({
            appState: customState
        })
    }

    handleAuthentication () {
        loggingService.log(isDebug, 'authService', 'handle authentication')
        return new Promise((resolve, reject) => {
            webAuth.parseHash((err, authResult) => {
                if (err) {
                    reject(err)
                    //router.replace('/')
                } else {
                    this.setSession(authResult)
                    resolve(authResult.idToken)
                    //router.replace('/')
                }
            })
        })
        // this.auth0.parseHash((err, authResult) => {
        // if (authResult && authResult.accessToken && authResult.idToken) {
        //     this.setSession(authResult)
        //     router.replace('/')
        // } else if (err) {
        //     router.replace('/')
        //     console.log(err)
        //     alert(`Error: ${err.error}. Check the console for further details.`)
        // }
        // })
    }

    setSession (authResult) {
        this.idToken = authResult.idToken
        this.profile = authResult.idTokenPayload
        this.tokenExpiry = new Date(this.profile.exp * 1000)
        loggingService.log(isDebug, 'authService', 'token expires at: ' + this.tokenExpiry)

        localStorage.setItem(lsKeySignedIn, 'true')
        // Set the time that the access token will expire at
        let expiresAt = JSON.stringify(
            this.profile.exp * 1000
        )
        
        localStorage.setItem(lsKeyIdToken, authResult.idToken)
        localStorage.setItem(lsKeyExpireAt, expiresAt)
        // localStorage.setItem(lsKeyProfile, JSON.stringify(authResult.idTokenPayload))
        //localStorage.setItem('authResult', JSON.stringify(authResult))
        this.authenticated = this.isAuthenticated()
        store.dispatch('auth/authenticated', authResult).then(result => {
            // console.log('store.dispatch - auth/authenticated')
            // console.log(store.state.auth)
        })
        this.emit(loginEvent, { authenticated: true, authResult: authResult })
    }

    logout () {
        this.clearLoginCache()
        // navigate to the home route and reload page
        webAuth.logout({
            returnTo: window.location.origin
        })
        //router.push('/')
    }

    clearLoginCache () {
        this.idToken = null
        this.tokenExpiry = null
        this.profile = null

        store.dispatch('auth/logout')
        // Clear access token and ID token from local storage
        localStorage.removeItem(lsKeyIdToken)
        localStorage.removeItem(lsKeyExpireAt)
        // localStorage.removeItem(lsKeyProfile)
        localStorage.removeItem(lsKeySignedIn)
        //localStorage.removeItem('authResult')
        this.authenticated = this.isAuthenticated()
        this.emit(loginEvent, { authenticated: false, authResult: null })
    }

    isAuthenticated () {
        const expiresAt = JSON.parse(localStorage.getItem(lsKeyExpireAt))
        return (
            Date.now() < expiresAt &&
            localStorage.getItem(lsKeySignedIn) === 'true'
        )
    }

    renewTokens() {
        return new Promise((resolve, reject) => {
            if (localStorage.getItem(lsKeySignedIn) !== 'true') {
                loggingService.log(isDebug, 'authService', 'renewTokens - error - User not logged in')
                this.clearLoginCache()
                return reject("User not logged in");
            }

            webAuth.checkSession({}, (err, authResult) => {
                if (err) {
                    loggingService.log(isDebug, 'authService', 'renewTokens - error')
                    loggingService.logRaw(isDebug, err)
                    this.logout()
                    reject(err);
                } else {
                    loggingService.log(isDebug, 'authService', 'renewTokens - success')
                    loggingService.logRaw(isDebug, authResult)
                    this.setSession(authResult);
                    resolve(authResult);
                }
            });
        });
    }

}

export default new AuthService()